import { all, takeLatest, put, call } from 'redux-saga/effects';
import { getClaimOrganizationsWithAccess } from '../claim/slice';
import { getClaimMessageRecipientOrganizations, getWorklistClaimRecommendations } from '../worklistClaims/slice';
import {
  onGetClaimAuthorizedOrganisations,
  onAddClaimAuthorizedOrganisations,
  onDeleteClaimAuthorizedOrganisations
} from './api';
import {
  getClaimAuthorizedOrganizations,
  getClaimAuthorizedOrganizationsSucceeded,
  getClaimAuthorizedOrganizationsFailed,
  updateClaimAuthorizedOrganizations,
  updateClaimAuthorizedOrganizationsSucceeded,
  updateClaimAuthorizedOrganizationsFailed
} from './slice';

export function* getClaimAuthorizedOrganizationsWorker({ payload }) {
  const { claimId } = payload;

  try {
    const response = yield call(onGetClaimAuthorizedOrganisations, claimId);
    yield put(getClaimAuthorizedOrganizationsSucceeded(response.data));
  } catch {
    yield put(getClaimAuthorizedOrganizationsFailed());
  }
}

export function* updateClaimAuthorizedOrganizationsWorker({ payload }) {
  const { organizationsToAdd, organizationsToRemove, claimId, callback } = payload;

  try {
    let organizationsToAddResponse = null;
    let organizationsToRemoveResponse = null;

    if (organizationsToAdd && organizationsToAdd.length > 0) {
      const parsedOrganizationsToAdd = organizationsToAdd.map((orgId) => ({
        organization_id: orgId,
        claim_id: claimId
      }));
      organizationsToAddResponse = yield call(onAddClaimAuthorizedOrganisations, parsedOrganizationsToAdd);
    }
    if (organizationsToRemove && organizationsToRemove.length > 0) {
      organizationsToRemoveResponse = yield call(onDeleteClaimAuthorizedOrganisations, organizationsToRemove);
    }

    const isSuccess = (response) =>
      response !== null && response !== undefined && response.status >= 200 && response.status < 300;

    if (isSuccess(organizationsToAddResponse) || isSuccess(organizationsToRemoveResponse)) {
      yield all([
        put(updateClaimAuthorizedOrganizationsSucceeded({ claimId })),
        put(getWorklistClaimRecommendations({ claimId }))
      ]);

      callback?.();
    } else {
      yield put(updateClaimAuthorizedOrganizationsFailed());
    }
  } catch {
    yield put(updateClaimAuthorizedOrganizationsFailed());
  }
}

export function* reloadClaimOrganizationsWithAccessWorker({ payload }) {
  const { claimId } = payload;
  yield put(getClaimOrganizationsWithAccess({ claimId }));
  yield put(getClaimMessageRecipientOrganizations({ claimId }));
}

export default function* claimAuthorizationsSaga() {
  yield all([
    takeLatest(getClaimAuthorizedOrganizations.type, getClaimAuthorizedOrganizationsWorker),
    takeLatest(updateClaimAuthorizedOrganizations.type, updateClaimAuthorizedOrganizationsWorker),
    takeLatest(updateClaimAuthorizedOrganizationsSucceeded.type, reloadClaimOrganizationsWithAccessWorker)
  ]);
}
